import React from "react";
import { Table, Button } from "react-bootstrap";

const TablaCitasFicticias = ({
    citas,
    loading,
    pagina,
    totalPaginas,
    totalCitas,
    setPagina,
    onDesbloquear
}) => {
    if (loading) return <p>Cargando bloqueos de horario...</p>;
    if (citas.length === 0) return <p className="text-muted">No hay franjas horarias bloqueadas.</p>;

    return (
        <div>
            <h4 style={{ color: "#dc3545", marginBottom: "15px", fontWeight: "600" }}>Huecos Bloqueados (Citas ficticias)</h4>
            
            <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "15px" }}>
                <Button size="sm" variant="secondary" disabled={pagina === 1} onClick={() => setPagina(p => p - 1)}>Anterior</Button>
                <span>Página {pagina} de {totalPaginas} ({totalCitas} bloqueos)</span>
                <Button size="sm" variant="secondary" disabled={pagina >= totalPaginas} onClick={() => setPagina(p => p + 1)}>Siguiente</Button>
            </div>

            <Table hover responsive className="tabla-administracion shadow-sm">
                <thead className="table-danger">
                    <tr>
                        <th>Fecha</th>
                        <th>Identificador</th>
                        <th>Duración</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {citas.map((cita) => (
                        <tr key={cita.id} className="table-light">
                            <td style={{ fontWeight: "500" }}>{new Date(cita.hora).toLocaleString()}</td>
                            <td className="text-monospace text-danger">{cita.nombre}</td>
                            <td>{cita.duracion} min</td>
                            <td style={{ width: "140px" }}>
                                <Button 
                                    variant="outline-danger" 
                                    size="sm" 
                                    style={{ fontSize: "0.75rem", padding: "3px 8px", width: "100%", fontWeight: "500" }}
                                    onClick={() => onDesbloquear(cita.id)}
                                >
                                    Desbloquear
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default TablaCitasFicticias;